import { Amplify, Auth } from 'aws-amplify'
import { COGNITO_CONFIG } from './config'

const appOrigin = `${window.location.protocol}//${window.location.host}`

Amplify.configure({
    Auth: {
        region: COGNITO_CONFIG.region,
        userPoolId: COGNITO_CONFIG.userPoolId,
        userPoolWebClientId: COGNITO_CONFIG.userPoolWebClientId,
        mandatorySignIn: true,
        redirectSignIn: appOrigin,
        cookieStorage: {
            domain: process.env.REACT_APP_AUTH_COOKIE_DOMAIN || undefined,
            path: '/',
            expires: 365,
            secure: window.location.protocol === 'https:',
            sameSite: 'lax'
        }
    }
})

Auth.configure({
    oauth: {
        domain: COGNITO_CONFIG.oauthDomain,
        scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: appOrigin,
        redirectSignOut: appOrigin,
        responseType: 'code'
    }
})
